var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "污染物字典",
        okText: "确认",
        cancelText: "取消",
        width: "1000px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "CAS码",
                        prop: "cas",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.cas,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "cas", $$v)
                          },
                          expression: "formState.cas",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "中文通用名称",
                        prop: "cn",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.cn,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "cn", $$v)
                          },
                          expression: "formState.cn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "英文通用名称",
                        prop: "en",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.en,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "en", $$v)
                          },
                          expression: "formState.en",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "类别",
                        prop: "type",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "type", $$v)
                          },
                          expression: "formState.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "用途",
                        prop: "useFor",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.useFor,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "useFor", $$v)
                          },
                          expression: "formState.useFor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "残留物中文名称",
                        prop: "canliuCn",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.canliuCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "canliuCn", $$v)
                          },
                          expression: "formState.canliuCn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "残留物英文名称",
                        prop: "canliuEn",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.canliuEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "canliuEn", $$v)
                          },
                          expression: "formState.canliuEn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "污染物性质",
                        prop: "level",
                      },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "BadXingZhi" },
                        model: {
                          value: _vm.formState.level,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "level", $$v)
                          },
                          expression: "formState.level",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "分子式",
                        prop: "fenzishi",
                      },
                    },
                    [
                      _c("a-ext-upload", {
                        model: {
                          value: _vm.formState.fenzishi,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "fenzishi", $$v)
                          },
                          expression: "formState.fenzishi",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }